<template>
    <div class="express-package-detail">
        <compWrapper :title="this.$t('fbb.expresspackage.baseinfo',{defaultValue:'基本信息'})" theme="primary">
            <compFormQuery
                class="margin-top-15"
                :formdata="getBase"
                :value="formData"
                placeholder="--"
            ></compFormQuery>
        </compWrapper>
        <compWrapper :title="this.$t('fbb.expresspackage.package_info',{defaultValue:'包裹信息'})" theme="info">
            <compFormQuery
                class="margin-top-15"
                :formdata="getPackage"
                :value="formData"
                placeholder="--"
            ></compFormQuery>
        </compWrapper>
    </div>
</template>

<script>
import mixin from './mixin';
import {
    HttpGetPackgeDetail
} from '@/service/expresspackage';
export default {
    props: ['id'],
    mixins: [mixin],
    data() {
        return {
            formData: {},
        };
    },
    created () {
        // 获取详情
        HttpGetPackgeDetail({
            id: this.id,
            contextId: global.SYSID
        }).then(res => {
            this.formData = {
                ...res.data
            }
        }, err => {
            this.$VMessage.error(err.message);
        });
    },
    computed: {
        getBase() {
            return [
                // {
                //     label: "测试",
                //     render: (h) => {
                //         return <div>{this.formData.num}</div>;
                //     },
                // },
                {
                    label: this.$t('fbb.expresspackage.head_id',{defaultValue:'销售出库计划单号'}),
                    key: 'headId'
                },
                // {
                //     label: "仓库",
                //     key: "",
                // },
                {
                    label: this.$t('fbb.expresspackage.deliver_order_id',{defaultValue:'来源单ID'}),
                    key: "deliverOrderId",
                },
                {
                    label: this.$t('fbb.expresspackage.deliver_order_no',{defaultValue:'来源单号'}),
                    key: "deliverOrderNo",
                },
                {
                    label: this.$t('fbb.expresspackage.erp_sku',{defaultValue:'SKU'}),
                    key: "erpSku",
                },
                {
                    label: this.$t('fbb.expresspackage.shiped_quantity',{defaultValue:'发运数量'}),
                    key: "shipedQuantity",
                },
                {
                    label: this.$t('fbb.expresspackage.service_code',{defaultValue:'承运商'}),
                    key: "serviceCode",
                },
                {
                    label: this.$t('fbb.expresspackage.shipment_date',{defaultValue:'出库时间'}),
                    key: "shipmentDate",
                },
                {
                    label: this.$t('fbb.expresspackage.actual_service_code',{defaultValue:'实际承运商'}),
                    key: "serviceCode",
                },
            ];
        },
        getPackage() {
            return [
                {
                    label: this.$t('fbb.expresspackage.track_no',{defaultValue:'物流单号'}),
                    key: "trackNo",
                    render: (h) => {
                        let fedexUrl = `https://www.fedex.com/apps/fedextrack/?action=track&tracknumbers=${this.formData.trackNo}&locale=en_US&cntry_code=ratetools`;
                        return (
                            <div>
                                <a target="_blank" href={fedexUrl}>
                                    {this.formData.trackNo}
                                </a>
                            </div>
                        );
                    },
                },
                {
                    label: this.$t('fbb.expresspackage.shipping_cost_currency',{defaultValue:'币种'}),
                    key: "shippingCostCurrency",
                },
                {
                    label: this.$t('fbb.expresspackage.package_length',{defaultValue:'包裹长'})+'(cm)',
                    key: "packageLength",
                },
                {
                    label: this.$t('fbb.expresspackage.package_width',{defaultValue:'包裹宽'})+'(cm)',
                    key: "packageWidth",
                },
                {
                    label: this.$t('fbb.expresspackage.package_height',{defaultValue:'包裹高'})+'(cm)',
                    key: "packageHeight",
                },
                {
                    label: this.$t('fbb.expresspackage.package_weight',{defaultValue:'包裹重量'})+'(g)',
                    key: "packageWeight",
                },
                {
                    label: this.$t('fbb.expresspackage.actual_package_length',{defaultValue:'包裹实际长(cm)'}),
                    key: "packageLength",
                },
                {
                    label: this.$t('fbb.expresspackage.actual_package_width',{defaultValue:'包裹实际宽(cm)'}),
                    key: "packageWidth",
                },
                {
                    label: this.$t('fbb.expresspackage.actual_package_height',{defaultValue:'包裹实际高(cm)'}),
                    key: "packageHeight",
                },
                {
                    label: this.$t('fbb.expresspackage.actual_package_weight',{defaultValue:'包裹实际重量(g)'}),
                    key: "packageWeight",
                },
                // {
                //     label: "实际导入时间",
                //     key: "",
                // },
                {
                    label: this.$t('fbb.expresspackage.logistic_status',{defaultValue:'物流状态'}),
                    render: (h) => {
                        let statusName = this.getLogisticStatus.filter(item => {
                            return this.formData.logisticStatus === item.value
                        })[0];
                        statusName = statusName.label ? statusName.label : '--';
                        return <div>{statusName}</div>
                    }
                },
                {
                    label: this.$t('fbb.expresspackage.label_created_at',{defaultValue:'Label创建时间'}),
                    key: "shipmentDate",
                },
                {
                    label: this.$t('fbb.expresspackage.first_scanned_at',{defaultValue:'扫件时间'}),
                    key: "firstScannedAt",
                },
                {
                    label:this.$t('fbb.expresspackage.delivered_at',{defaultValue:'妥投时间'}),
                    key: "deliveryedAt",
                },
                {
                    label: this.$t("global.common.update_time",{defaultValue:'更新时间'}),
                    key: "updatedAt",
                },
                // {
                //     label: "异常状态",
                //     key: "",
                // },
            ];
        },
    },
};
</script>

<style>
</style>
